export enum EDetailsQueryNames {
  GetApplicationDetails = 'getApplicationDetails',
  GetBaseOptionSetDetails = 'getBaseOptionSetDetails',
  GetBaseRequirementDetails = 'getBaseRequirementDetails',
  GetCountrySetupDetails = 'getCountrySetupDetails',
  GetCountryTemplateDetails = 'getCountryTemplateDetails',
  GetIndustryDetails = 'getIndustryDetails',
  GetOccupationDetails = 'getOccupationDetails',
  GetPriceRuleDetails = 'getPriceRuleDetails',
  GetOptionSetDetails = 'getOptionSetDetails',
  GetSurveyQuestionDetails = 'getSurveyQuestionDetails',
  GetOrganisationDetails = 'getOrganisationDetails',
  GetSecondaryIndustryDetails = 'getSecondaryIndustryDetails',
  GetAccountDetails = 'getAccountDetails',
  GetPartnerDetails = 'getPartnerDetails',
  GetUserDetailsCRM = 'getUserDetailsCRM',
  GetRequirementDetails = 'getRequirementDetails',
  GetPromoCodeDetails = 'getPromoCodeDetails',
}
